import { FC, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { FilterDropdownTrigger } from "../../../FilterDropdownTrigger";
import { useAppSelector } from "../../../../../../../../../store/hooks";
import { resourceExplorerPossibleFiltersByProviderSelector } from "../../../../../../../../../store/resource-explorer/selectors/filters/possible-filters/resourceExplorerPossibleFiltersByProviderSelector";
import { resourceExplorerFilterByKeyAndProviderSelector } from "../../../../../../../../../store/resource-explorer/selectors/filters/resourceExplorerFilterByKeyAndProviderSelector";
import {
  ResourceExplorerFilterItem,
  ProviderType,
} from "../../../../../../../../../services/cloudchipr.api";
import { chargeTypeFilterChangeThunk } from "../../../../../../../../../store/resource-explorer/thunks/filters/chargeTypeFilterChangeThunk";
import { isDeepEqual } from "../../../../../../../../../utils/is-deep-equal";
import { dbSelectedChargeTypeSelector } from "../../../../../../../../../store/resource-explorer/selectors/filters/selected/dbSelectedChargeTypeSelector";
import { DropdownSelect } from "../../../../../../../../common/select/dropdown-select/DropdownSelect";

interface ResourceExplorerAccountFilterProps {
  viewId: string;
  provider: ProviderType;
}
export const ResourceExplorerChargeTypeFilter: FC<
  ResourceExplorerAccountFilterProps
> = ({ viewId, provider }) => {
  const dispatch = useDispatch();
  const filter = useAppSelector((state) =>
    resourceExplorerFilterByKeyAndProviderSelector(
      state,
      "charge_type",
      provider,
    ),
  );

  const possibleFilters = useAppSelector((state) =>
    resourceExplorerPossibleFiltersByProviderSelector(state, provider),
  )?.charge_type;

  const selectedFilter = useAppSelector((state) =>
    dbSelectedChargeTypeSelector(state, provider),
  );

  const options = useMemo(() => {
    return (
      possibleFilters?.values?.map((option) => {
        return {
          value: option.value,
          label: option.title || option.value,
        };
      }) ?? []
    );
  }, [possibleFilters]);

  const submitHandlerOnClose = useCallback(
    (value: string[]) => {
      const newFilter: ResourceExplorerFilterItem = {
        ...filter,
        value,
        key: "charge_type",
        operator: "in",
        cloud_provider: provider,
        include_values: filter?.include_values ?? null,
      };

      const isEqual = filter && isDeepEqual(newFilter, filter);

      if (!isEqual) {
        dispatch(chargeTypeFilterChangeThunk({ filter: newFilter, provider }));
      }
    },
    [dispatch, filter, provider],
  );

  const TriggerComponent = useCallback(
    (props: any) => (
      <FilterDropdownTrigger
        {...props}
        viewId={viewId}
        provider={provider}
        filterKey="charge_type"
        title="Charge Types"
      />
    ),
    [provider, viewId],
  );

  return (
    <DropdownSelect
      label="Charge Types"
      options={options}
      initialSelectedValues={(selectedFilter.value ?? []) as string[]}
      submitHandlerOnClose={submitHandlerOnClose}
      TriggerComponent={TriggerComponent}
      values={(selectedFilter.value ?? []) as string[]}
    />
  );
};
